import { Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  title: string;
  leftText: string;
  rightText: string;
  contactScore: number | undefined;
  userScore: number | undefined;
}

const isAlmostEqual = (firstVal: number, secondVal: number) => {
  const difference = Math.abs(firstVal - secondVal);
  return difference > 1.25 ? false : true;
};

const MatchCompareGraph: React.FC<Props> = ({ title, leftText, rightText, contactScore, userScore }) => {
  const { classes } = useStyles({
    contactScoreNorm: (contactScore ?? 0) * 100,
    userScoreNorm: (userScore ?? 0) * 100,
  });

  return (
    <div className={classes.card}>
      <div style={{ width: '100%' }}>
        <div>
          <Typography className={classes.title}>{title}</Typography>
        </div>
        <div className={classes.graph}>
          {!_.isNil(contactScore) ? <div className={classes.contactScore} /> : null}
          {!_.isNil(userScore) ? <div className={classes.userScore} /> : null}
          <div className={classes.leftText}>
            <Typography className={classes.graphText}>{leftText}</Typography>
          </div>
          <div className={classes.rightText}>
            <Typography className={classes.graphText}>{rightText}</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles<{ contactScoreNorm: number; userScoreNorm: number }>()((theme, { contactScoreNorm, userScoreNorm }) => ({
  card: {
    width: '100%',
    height: '100%',
    background: '#FFF',
    padding: '8px 16px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    marginBottom: '16px',
  },
  graph: {
    position: 'relative',
    height: '4px',
    width: '100%',
    background: theme.palette.greys.light,
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    margin: '5.5px 0 24px 0',
  },
  contactScore: {
    height: isAlmostEqual(contactScoreNorm, userScoreNorm) ? '10px' : '15px',
    width: isAlmostEqual(contactScoreNorm, userScoreNorm) ? '10px' : '15px',
    zIndex: isAlmostEqual(contactScoreNorm, userScoreNorm) ? '9999' : undefined,
    position: 'absolute',
    background: theme.palette.analysisSecondary.main,
    left: `calc(${contactScoreNorm}% - 7.5px)`,
    border: '1px solid #FFF',
    borderRadius: '4px',
  },
  userScore: {
    height: '15px',
    width: '15px',
    position: 'absolute',
    background: theme.palette.primary.main,
    left: `calc(${userScoreNorm}% - 7.5px)`,
    border: '1px solid #FFF',
    borderRadius: '4px',
  },
  graphText: {
    fontSize: theme.typography.pxToRem(11),
    textTransform: 'capitalize',
  },
  leftText: {
    position: 'absolute',
    textAlign: 'left',
    left: 0,
    top: '12px',
  },
  rightText: {
    position: 'absolute',
    textAlign: 'right',
    right: 0,
    top: '12px',
  },
}));

export default MatchCompareGraph;
